import { FormLayoutAppearance } from 'src/app/layout/form-layout/form-layout.types'
import { ReservationF } from '../../types/reservation-detail.types'
import ReferenceFormHook, { ReferenceFormSchema } from './reference-form.hook'
import FormLayout from 'src/app/layout/form-layout/form-layout'
import { FormLayoutDefaultToolbar } from 'src/app/layout/form-layout/form-layout-toolbar'
import { Grid } from '@vapor/material'
import { Controller } from 'react-hook-form'
import { FormItem } from 'hic-components'
import PersonLookup from 'src/app/components/customer-lookup/person-lookup'
import CompanyLookup from 'src/app/components/customer-lookup/company-lookup'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBed, faBuilding, faHandshakeAngle, faUser } from '@fortawesome/pro-regular-svg-icons'

export default function ReferenceForm({
  reservation,
  appearance,
  title,
  loading,
  onSubmit,
  onCancel,
}: {
  reservation: ReservationF
  appearance: FormLayoutAppearance
  title: string
  loading: boolean
  onSubmit: (data: ReferenceFormSchema) => Promise<void>
  onCancel: () => void
}) {
  const { t } = useTranslation()
  const { onFormSubmit, control, errors } = ReferenceFormHook({ reservation, onSubmit })

  return (
    <FormLayout
      appearance={appearance}
      title={title}
      toolbar={
        <FormLayoutDefaultToolbar
          saveButton={{
            loading: loading,
            disabled: loading,
            clickHandler: onFormSubmit,
          }}
          cancelButton={{
            loading: loading,
            disabled: loading,
            clickHandler: onCancel,
          }}
        />
      }
    >
      <form onSubmit={onFormSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Controller<ReferenceFormSchema, 'customerPersonId'> //
              name={'customerPersonId'}
              control={control}
              render={({ field }) => (
                <FormItem
                  fieldLabel={
                    <>
                      <FontAwesomeIcon icon={faUser} style={{ marginRight: '4px' }} />
                      {t('pms.booking.reservation.reference.customer_person')}
                    </>
                  }
                  errorMessage={errors?.customerPersonId?.message}
                  fullWidth
                  sx={{ '& .MuiAutocomplete-root': { maxWidth: '250px' } }}
                >
                  <PersonLookup //
                    error={errors?.customerPersonId ? true : false}
                    value={field.value ? { id: field.value } : null}
                    onChange={(value) => {
                      field.onChange(value?.id || null)
                    }}
                    createAction
                    updateAction
                    disabled={loading}
                    size='small'
                  />
                </FormItem>
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller<ReferenceFormSchema, 'mainGuestId'> //
              name={'mainGuestId'}
              control={control}
              render={({ field }) => (
                <FormItem
                  fieldLabel={
                    <>
                      <FontAwesomeIcon icon={faBed} style={{ marginRight: '4px' }} />
                      {t('pms.booking.reservation.reference.main_guest')}
                    </>
                  }
                  errorMessage={errors?.mainGuestId?.message}
                  fullWidth
                  sx={{ '& .MuiAutocomplete-root': { maxWidth: '250px' } }}
                >
                  <PersonLookup //
                    error={errors?.mainGuestId ? true : false}
                    value={field.value ? { id: field.value } : null}
                    onChange={(value) => {
                      field.onChange(value?.id || null)
                    }}
                    createAction
                    updateAction
                    disabled={loading}
                    size='small'
                  />
                </FormItem>
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller<ReferenceFormSchema, 'customerCompanyId'> //
              name={'customerCompanyId'}
              control={control}
              render={({ field }) => (
                <FormItem
                  fieldLabel={
                    <>
                      <FontAwesomeIcon icon={faBuilding} style={{ marginRight: '4px' }} />
                      {t('pms.booking.reservation.reference.customer_company')}
                    </>
                  }
                  errorMessage={errors?.customerCompanyId?.message}
                  fullWidth
                  sx={{ '& .MuiAutocomplete-root': { maxWidth: '250px' } }}
                >
                  <CompanyLookup //
                    error={errors?.customerCompanyId ? true : false}
                    value={field.value ? { id: field.value } : null}
                    onChange={(value) => {
                      field.onChange(value?.id || null)
                    }}
                    createAction
                    updateAction
                    disabled={loading}
                    size='small'
                  />
                </FormItem>
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller<ReferenceFormSchema, 'agencyId'> //
              name={'agencyId'}
              control={control}
              render={({ field }) => (
                <FormItem
                  fieldLabel={
                    <>
                      <FontAwesomeIcon icon={faHandshakeAngle} style={{ marginRight: '4px' }} />
                      {t('pms.booking.reservation.reference.agency')}
                    </>
                  }
                  errorMessage={errors?.agencyId?.message}
                  fullWidth
                  sx={{ '& .MuiAutocomplete-root': { maxWidth: '250px' } }}
                >
                  <CompanyLookup //
                    error={errors?.agencyId ? true : false}
                    value={field.value ? { id: field.value } : null}
                    onChange={(value) => {
                      field.onChange(value?.id || null)
                    }}
                    createAction
                    updateAction
                    disabled={loading}
                    size='small'
                  />
                </FormItem>
              )}
            />
          </Grid>
        </Grid>
      </form>
    </FormLayout>
  )
}
